import { render, staticRenderFns } from "./report-found-picture.vue?vue&type=template&id=0c40b25a"
import script from "./report-found-picture.vue?vue&type=script&lang=js"
export * from "./report-found-picture.vue?vue&type=script&lang=js"
import style0 from "./report-found-picture.vue?vue&type=style&index=0&id=0c40b25a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports